import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { UserService } from '../../../services/user.service';
import { PopupService } from '../../../services/popup.service';
import { Router } from "@angular/router";

@Component({
  selector: 'app-mobile-user-options',
  templateUrl: './mobile-user-options.component.html',
  styleUrls: ['./mobile-user-options.component.less'],
  encapsulation: ViewEncapsulation.None
})
export class MobileUserOptionsComponent implements OnInit {

	isApplicationDropdownOpen: boolean = false;

  constructor(public userService : UserService, public popupService: PopupService,
              public router: Router) { }

  ngOnInit() {
  }

   isAnyPopupOpened() {
    return (this.router.isActive('/map/log-in', false) || this.router.isActive('/map/sign-up', false) || this.router.isActive('/map/forgot-password', false))? 0 : 10002;
  }

  logout() {
    this.userService.logout().subscribe((response)=>{
      this.router.navigate(['']);
    }, (error)=>{
      throw(error);
    });
    this.userService.isMobileUserOptionsOpened = false;
  }

  openApplicationDropdown(toggle) {
    this.isApplicationDropdownOpen = toggle;
    (<any>window).Events.publish('detectChanges');
  }

  goToLandingPage() {
    this.router.navigate(['/']);
    this.openApplicationDropdown(false);
  }

  toggleSignIn() {
    (!this.popupService.popupList.popups['log-in'])?
      this.popupService.updateRoute('log-in'):
      this.popupService.updateRoute();
  }

  toggleSignUp() {
    (!this.popupService.popupList.popups['sign-up'])?
      this.popupService.updateRoute('sign-up'):
      this.popupService.updateRoute();
  }
}



// WEBPACK FOOTER //
// ./src/app/components/header/mobile-user-options/mobile-user-options.component.ts